import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../../utils/cn";

type CardProps = HTMLAttributes<HTMLDivElement> & {
  title?: string;
  description?: string;
  children?: ReactNode;
};

export const Card = ({ title, description, className, children, ...props }: CardProps) => (
  <div
    className={cn(
      "rounded-lg border border-border/50 bg-card/90 p-6 shadow-subtle",
      "backdrop-blur-lg transition-shadow hover:shadow-soft",
      className
    )}
    {...props}
  >
    {(title || description) && (
      <div className="mb-4">
        {title && <h3 className="text-lg font-semibold">{title}</h3>}
        {description && <p className="text-sm text-muted-foreground">{description}</p>}
      </div>
    )}
    {children}
  </div>
);
